import React, { Suspense, useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import Keycloak from 'keycloak-js';
import Cookies from 'js-cookie';

var config = require('./../config/appConfig.json');

const jwt = require('jsonwebtoken')


export const LoginCallbackPage = (props) => {
const [loading, setLoading] = useState(true);


useEffect(() => {
  async function fetchLoginApi(){
  const keycloak = Keycloak(window.location.origin+'/config/keycloak.json')
  await keycloak.init({
    onLoad: 'check-sso',
    silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html'
  })
  var expiresIn = new Date(new Date().getTime() + 30 * 60 * 1000);
  Cookies.set('session_token', keycloak.idToken, { expires: expiresIn } );

  // TODO: localStorage - changes removal of this and fetching from session at srever side  - wherever applied.
  localStorage.setItem('kc_access_token', keycloak.token);
  localStorage.setItem('kc_refresh_token', keycloak.refreshToken);
  localStorage.setItem('kc_id_token', keycloak.idToken);
  let nonce = localStorage.getItem('nonce');
  let state = localStorage.getItem('state');
  let redirect_uri = window.location.href;

  let kc_token = keycloak.token;
  let kd_refresh_token = keycloak.refreshToken;
  //----Only for Staging Now-------

  let kc_id_token = keycloak.idToken;
  console.log(`nonce: ${nonce}, state: ${state}`);

  // let res = await axios.get( config.serverUrl + '/api/tokens', {
  //   withCredentials: true,
  //   credentials: "include",
  //   headers: { "api-key": "bearer "+keycloak.token}
  // })

  //console.log("ibm tokens:", JSON.stringify(res));

  //console.log("ibm id token:", res.data.id_token);

  // let ibmIdToken = res.id_token;
  // let kc_id_token = res.data.id_token;

  let response = await axios.post(config.serverUrl + '/api/authenticate', { nonce, state, redirect_uri, kc_token, kd_refresh_token, kc_id_token }, { 
    withCredentials: true,
    credentials: "include",
  });

  localStorage.setItem('user', JSON.stringify(response.data));
  //----Only for Staging Now-------

  // console.log("kc_token",kc_token);
  
  let token = localStorage.getItem('kc_id_token');
  //Check except login and login callback i.e. for protected routes.
  if(token){
    const payload = jwt.decode(token);
    console.log("payload",payload);
    localStorage.setItem('user_name', JSON.stringify(payload.name));
    localStorage.setItem('roles', JSON.stringify(payload.roles));

  }
  setLoading(!loading);

  // getUserPreferences();
}

fetchLoginApi();
},[])


    if (!loading) {
      //console.log("VerifyToken render method");
      let user = JSON.parse(localStorage.getItem('user'))
      if (user !== null && user.access_token !== null) {  
        return (
        <Redirect  to={`/homePage`}/>
        );
      } else {
        //console.log(`render method else call, return null`)
        return null;
      }
    } else {
      return null;
    }
  }
